// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoArte_image__GNYPF","image_in":"LogoArte_image_in__Vl4cv"};